import { useLocalStorage } from 'usehooks-ts';

import { MockedTimeManager } from '../MockedTimeManager';
import useClientSide from './useClientSide';

/**
 * 모달 노출 쿨다운을 localStorage 기반으로 관리한다.
 *
 * - 쿨다운 만료 시각(epoch ms)을 단일 키에 저장하고 현재 시각과 비교해 노출 가능 여부를 판별한다
 * - 같은 키에 동작별로 다른 duration을 기록할 수 있어 다단계 억제(1일/7일 등)를 키 하나로 지원한다
 * - `executeCooldown`과 동일한 타임스탬프+duration 컨셉이지만, 세션 간 영속이 필요해 localStorage 기반 선언형으로 구현
 * - 서버/첫 클라이언트 렌더에서는 항상 쿨다운 중으로 두어 hydration mismatch를 방지한다
 */
export const useModalCooldown = (storageKey: string) => {
  const isClientSide = useClientSide();
  const [cooldownUntil, setCooldownUntil] = useLocalStorage<number | null>(
    storageKey,
    null,
    { initializeWithValue: false },
  );

  const isInCooldown =
    !isClientSide ||
    (cooldownUntil !== null &&
      MockedTimeManager.getInstance().getMockedTimestamp() < cooldownUntil);

  const startCooldown = (durationMs: number) =>
    setCooldownUntil(
      MockedTimeManager.getInstance().getMockedTimestamp() + durationMs,
    );

  return { isInCooldown, startCooldown };
};
